import axios, { AxiosResponse } from 'axios';

import { apiUrl } from '@/config/api';

import { ApiAccount } from './types/auth';
import { ApiTermsAndConditions } from './types/terms-and-conditions';

const getGtc = (token: string): Promise<AxiosResponse<ApiTermsAndConditions>> => {
    return axios.get(`${apiUrl}/trk/common/user/text-gtc`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const getDtp = (token: string): Promise<AxiosResponse<ApiTermsAndConditions>> => {
    return axios.get(`${apiUrl}/trk/common/user/text-dtp`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const confirmTermsAndConditions = (token: string): Promise<AxiosResponse<ApiAccount>> => {
    return axios.post(
        `${apiUrl}/trk/common/user/text-confirm`,
        {},
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );
};

export default {
    getGtc,
    getDtp,
    confirmTermsAndConditions,
};
